import React, { useRef } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { AttachFile as AttachFileIcon } from '@mui/icons-material';

interface MediaUploadButtonProps {
  onMediaSelect: (file: File, mediaType: string) => void;
  disabled?: boolean;
}

const MediaUploadButton: React.FC<MediaUploadButtonProps> = ({ 
  onMediaSelect, 
  disabled = false
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      let detectedMediaType = 'document';
      
      // Detect media type based on MIME type
      if (file.type.startsWith('image/')) {
        detectedMediaType = 'image';
      } else if (file.type.startsWith('audio/')) {
        detectedMediaType = 'audio';
      } else if (file.type.startsWith('video/')) {
        detectedMediaType = 'video';
      }
      
      // Validate file size (max 100MB)
      if (file.size > 100 * 1024 * 1024) {
        alert('File size must be less than 100MB');
        return;
      }
      
      console.log('📎 MediaUploadButton - File selected:', {
        name: file.name,
        type: file.type,
        size: file.size,
        detectedMediaType
      });
      
      onMediaSelect(file, detectedMediaType);
      
      // Reset input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <>
      <Tooltip title="Attach file">
        <IconButton
          onClick={handleClick}
          disabled={disabled}
          sx={{
            color: '#666',
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <AttachFileIcon />
        </IconButton>
      </Tooltip>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,audio/*,video/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </>
  );
};

export default MediaUploadButton;
